import comp from "./CollaboratorV2";
export default comp;
